import { useCallback, useState } from 'react';
import { removeCartItem } from '../api/botApi';
import { useBotContext } from '../store/BotContext';
import { useBotSession } from './useBotSession';
import { invalidateBotCheckoutCache } from './useBotCheckoutHandler';
import type { CheckoutPayload } from '../types/bot.types';

/** Direct cart-item removal for bot checkout UI (no LLM turn). */
export function useBotRemoveFromCart() {
  const { botState } = useBotContext();
  const { applyCheckoutPayload } = useBotSession();
  const [removingId, setRemovingId] = useState<string | null>(null);

  const removeItem = useCallback(
    async (cartItemId: string) => {
      const sessionId = botState.sessionId;
      if (!sessionId || removingId) return;
      setRemovingId(cartItemId);
      try {
        const payload: CheckoutPayload = await removeCartItem(sessionId, cartItemId);
        // Same contract as handleBotTurnComplete: the cart just changed, so a
        // checkout uuid minted earlier would re-book the removed item.
        invalidateBotCheckoutCache(sessionId);
        applyCheckoutPayload(payload);
      } catch (e) {
        console.error('[BotRemoveFromCart]', e);
      } finally {
        setRemovingId(null);
      }
    },
    [botState.sessionId, removingId, applyCheckoutPayload],
  );

  return { removeItem, removingId };
}
